import { defineComponent as m, computed as V, openBlock as l, createBlock as g, resolveDynamicComponent as D, normalizeStyle as F, normalizeClass as R, withCtx as c, renderSlot as $, createElementBlock as i, createCommentVNode as y, createElementVNode as v, useId as I, unref as a, createTextVNode as h, toDisplayString as b, createVNode as u, Fragment as x, renderList as B, readonly as N, ref as z, isRef as U, watch as j } from "vue";
import { DialogRoot as X, DialogPortal as E, DialogOverlay as O, DialogContent as Y, DialogTitle as K, DialogClose as J, DialogDescription as Q, CheckboxRoot as Z, CheckboxIndicator as ee, RadioGroupRoot as ae, RadioGroupItem as te, RadioGroupIndicator as oe, SelectRoot as le, SelectTrigger as re, SelectValue as ne, SelectIcon as se, SelectPortal as de, SelectContent as ie, SelectViewport as ce, SelectItem as ue, SelectItemIndicator as ve, SelectItemText as be, TabsRoot as fe, TabsList as ge, TabsTrigger as me, TabsContent as pe, ToastProvider as _e, ToastRoot as ye, ToastTitle as he, ToastDescription as ke, ToastClose as Se, ToastViewport as $e } from "reka-ui";
import { useVueTable as xe, getPaginationRowModel as Be, getFilteredRowModel as we, getSortedRowModel as Ie, getCoreRowModel as Re, FlexRender as M } from "@tanstack/vue-table";
import { useField as Ce } from "vee-validate";
const Te = /* @__PURE__ */ m({
  __name: "Box",
  props: {
    as: { default: "div" },
    padding: {},
    radius: {},
    background: {},
    bordered: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = V(() => {
      const o = {};
      return t.padding && (o.padding = `var(--space-${t.padding})`), t.radius && (o.borderRadius = `var(--radius-${t.radius})`), t.background && (o.background = `var(--color-${t.background})`), o;
    });
    return (o, n) => (l(), g(D(e.as), {
      class: R(["telar-box", { "telar-box--bordered": e.bordered }]),
      style: F(r.value)
    }, {
      default: c(() => [
        $(o.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class", "style"]));
  }
}), k = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [o, n] of t)
    r[o] = n;
  return r;
}, Ga = /* @__PURE__ */ k(Te, [["__scopeId", "data-v-a0ebc06b"]]), Aa = /* @__PURE__ */ m({
  __name: "Stack",
  props: {
    as: { default: "div" },
    direction: { default: "column" },
    gap: { default: "4" },
    align: { default: "stretch" },
    justify: { default: "start" },
    wrap: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = {
      start: "flex-start",
      center: "center",
      end: "flex-end",
      stretch: "stretch"
    }, o = {
      start: "flex-start",
      center: "center",
      end: "flex-end",
      between: "space-between"
    }, n = V(() => ({
      display: "flex",
      flexDirection: t.direction,
      gap: `var(--space-${t.gap})`,
      alignItems: r[t.align],
      justifyContent: o[t.justify],
      flexWrap: t.wrap ? "wrap" : "nowrap"
    }));
    return (s, d) => (l(), g(D(e.as), {
      style: F(n.value)
    }, {
      default: c(() => [
        $(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["style"]));
  }
}), La = /* @__PURE__ */ m({
  __name: "Text",
  props: {
    as: { default: "span" },
    size: { default: "md" },
    weight: { default: "regular" },
    tone: { default: "text" },
    align: {}
  },
  setup(e) {
    const t = e, r = V(() => {
      const o = {
        fontSize: `var(--font-size-${t.size})`,
        fontWeight: `var(--font-weight-${t.weight})`,
        color: `var(--color-${t.tone})`
      };
      return t.align && (o.textAlign = t.align), o;
    });
    return (o, n) => (l(), g(D(e.as), {
      style: F(r.value)
    }, {
      default: c(() => [
        $(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["style"]));
  }
}), Ve = ["role", "aria-label", "aria-hidden"], ze = /* @__PURE__ */ m({
  __name: "Icon",
  props: {
    size: {},
    label: {}
  },
  setup(e) {
    return (t, r) => (l(), i("span", {
      class: R(["telar-icon", `telar-icon--${e.size ?? "md"}`]),
      role: e.label ? "img" : void 0,
      "aria-label": e.label,
      "aria-hidden": e.label ? void 0 : "true"
    }, [
      $(t.$slots, "default", {}, void 0, !0)
    ], 10, Ve));
  }
}), Wa = /* @__PURE__ */ k(ze, [["__scopeId", "data-v-7bfb7ea9"]]), Me = ["type", "disabled", "aria-busy"], Pe = {
  key: 0,
  class: "telar-btn__spinner",
  "aria-hidden": "true"
}, De = { class: "telar-btn__label" }, Fe = /* @__PURE__ */ m({
  __name: "Button",
  props: {
    variant: { default: "primary" },
    size: { default: "md" },
    type: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    block: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const r = e, o = t, n = V(() => r.disabled || r.loading);
    function s(d) {
      n.value || o("click", d);
    }
    return (d, C) => (l(), i("button", {
      type: e.type,
      class: R(["telar-btn", [`telar-btn--${e.variant}`, `telar-btn--${e.size}`, { "telar-btn--block": e.block }]]),
      disabled: n.value,
      "aria-busy": e.loading ? "true" : void 0,
      onClick: s
    }, [
      e.loading ? (l(), i("span", Pe)) : y("", !0),
      v("span", De, [
        $(d.$slots, "default", {}, void 0, !0)
      ])
    ], 10, Me));
  }
}), P = /* @__PURE__ */ k(Fe, [["__scopeId", "data-v-b5eb384a"]]), Ge = ["for"], Ae = {
  key: 0,
  class: "telar-field__required",
  "aria-hidden": "true"
}, Le = ["id", "type", "value", "placeholder", "disabled", "required", "aria-invalid", "aria-describedby"], We = ["id"], qe = ["id"], He = /* @__PURE__ */ m({
  __name: "Input",
  props: {
    modelValue: {},
    label: {},
    description: {},
    error: {},
    type: { default: "text" },
    placeholder: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    size: { default: "md" }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = I(), o = I(), n = I(), s = V(() => {
      const d = [];
      return t.description && !t.error && d.push(o), t.error && d.push(n), d.length ? d.join(" ") : void 0;
    });
    return (d, C) => (l(), i("div", {
      class: R(["telar-field", `telar-field--${e.size}`])
    }, [
      e.label ? (l(), i("label", {
        key: 0,
        for: a(r),
        class: "telar-field__label"
      }, [
        h(b(e.label) + " ", 1),
        e.required ? (l(), i("span", Ae, "*")) : y("", !0)
      ], 8, Ge)) : y("", !0),
      v("input", {
        id: a(r),
        class: R(["telar-input", { "telar-input--invalid": e.error }]),
        type: e.type,
        value: e.modelValue,
        placeholder: e.placeholder,
        disabled: e.disabled,
        required: e.required,
        "aria-invalid": e.error ? "true" : void 0,
        "aria-describedby": s.value,
        onInput: C[0] || (C[0] = (_) => d.$emit("update:modelValue", _.target.value))
      }, null, 42, Le),
      e.description && !e.error ? (l(), i("p", {
        key: 1,
        id: a(o),
        class: "telar-field__desc"
      }, b(e.description), 9, We)) : y("", !0),
      e.error ? (l(), i("p", {
        key: 2,
        id: a(n),
        class: "telar-field__error",
        role: "alert"
      }, b(e.error), 9, qe)) : y("", !0)
    ], 2));
  }
}), W = /* @__PURE__ */ k(He, [["__scopeId", "data-v-dd602d49"]]), Ne = { class: "telar-modal__header" }, Ue = { class: "telar-modal__body" }, je = {
  key: 1,
  class: "telar-modal__footer"
}, Xe = /* @__PURE__ */ m({
  __name: "Modal",
  props: {
    open: { type: Boolean, default: !1 },
    title: {},
    description: {}
  },
  emits: ["update:open"],
  setup(e, { emit: t }) {
    const r = t;
    return (o, n) => (l(), g(a(X), {
      open: e.open,
      "onUpdate:open": n[0] || (n[0] = (s) => r("update:open", s))
    }, {
      default: c(() => [
        u(a(E), null, {
          default: c(() => [
            u(a(O), { class: "telar-modal__overlay" }),
            u(a(Y), { class: "telar-modal__content" }, {
              default: c(() => [
                v("header", Ne, [
                  u(a(K), { class: "telar-modal__title" }, {
                    default: c(() => [
                      h(b(e.title), 1)
                    ]),
                    _: 1
                  }),
                  u(a(J), {
                    class: "telar-modal__close",
                    "aria-label": "Cerrar"
                  }, {
                    default: c(() => [...n[1] || (n[1] = [
                      v("span", { "aria-hidden": "true" }, "×", -1)
                    ])]),
                    _: 1
                  })
                ]),
                e.description ? (l(), g(a(Q), {
                  key: 0,
                  class: "telar-modal__desc"
                }, {
                  default: c(() => [
                    h(b(e.description), 1)
                  ]),
                  _: 1
                })) : y("", !0),
                v("div", Ue, [
                  $(o.$slots, "default", {}, void 0, !0)
                ]),
                o.$slots.footer ? (l(), i("footer", je, [
                  $(o.$slots, "footer", {}, void 0, !0)
                ])) : y("", !0)
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), qa = /* @__PURE__ */ k(Xe, [["__scopeId", "data-v-686193ef"]]), Ee = { class: "telar-checkbox" }, Oe = ["for"], Ye = /* @__PURE__ */ m({
  __name: "Checkbox",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: {},
    disabled: { type: Boolean, default: !1 },
    id: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = I(), o = t.id ?? r;
    return (n, s) => (l(), i("div", Ee, [
      u(a(Z), {
        id: a(o),
        class: "telar-checkbox__box",
        "model-value": e.modelValue,
        disabled: e.disabled,
        "onUpdate:modelValue": s[0] || (s[0] = (d) => n.$emit("update:modelValue", d === !0))
      }, {
        default: c(() => [
          u(a(ee), { class: "telar-checkbox__indicator" }, {
            default: c(() => [...s[1] || (s[1] = [
              v("svg", {
                viewBox: "0 0 16 16",
                "aria-hidden": "true",
                focusable: "false"
              }, [
                v("path", {
                  d: "M13.5 4.5 6.5 11.5 2.5 7.5",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)
            ])]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["id", "model-value", "disabled"]),
      e.label ? (l(), i("label", {
        key: 0,
        for: a(o),
        class: "telar-checkbox__label"
      }, b(e.label), 9, Oe)) : y("", !0)
    ]));
  }
}), Ha = /* @__PURE__ */ k(Ye, [["__scopeId", "data-v-04c49215"]]), Ke = ["for"], Je = /* @__PURE__ */ m({
  __name: "RadioGroup",
  props: {
    modelValue: {},
    options: {},
    label: {},
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = I(), r = (o) => `${t}-${o}`;
    return (o, n) => (l(), g(a(ae), {
      class: "telar-radio",
      "model-value": e.modelValue,
      disabled: e.disabled,
      "aria-label": e.label,
      "onUpdate:modelValue": n[0] || (n[0] = (s) => o.$emit("update:modelValue", String(s)))
    }, {
      default: c(() => [
        (l(!0), i(x, null, B(e.options, (s, d) => (l(), i("div", {
          key: s.value,
          class: "telar-radio__option"
        }, [
          u(a(te), {
            id: r(d),
            class: "telar-radio__item",
            value: s.value
          }, {
            default: c(() => [
              u(a(oe), { class: "telar-radio__indicator" })
            ]),
            _: 1
          }, 8, ["id", "value"]),
          v("label", {
            for: r(d),
            class: "telar-radio__label"
          }, b(s.label), 9, Ke)
        ]))), 128))
      ]),
      _: 1
    }, 8, ["model-value", "disabled", "aria-label"]));
  }
}), Na = /* @__PURE__ */ k(Je, [["__scopeId", "data-v-123f9c23"]]), Qe = { class: "telar-select" }, Ze = ["for"], ea = /* @__PURE__ */ m({
  __name: "Select",
  props: {
    modelValue: {},
    options: {},
    label: {},
    placeholder: { default: "Selecciona…" },
    disabled: { type: Boolean, default: !1 },
    id: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = I(), o = t.id ?? r;
    return (n, s) => (l(), i("div", Qe, [
      e.label ? (l(), i("label", {
        key: 0,
        for: a(o),
        class: "telar-select__label"
      }, b(e.label), 9, Ze)) : y("", !0),
      u(a(le), {
        "model-value": e.modelValue,
        disabled: e.disabled,
        "onUpdate:modelValue": s[0] || (s[0] = (d) => n.$emit("update:modelValue", String(d)))
      }, {
        default: c(() => [
          u(a(re), {
            id: a(o),
            class: "telar-select__trigger",
            "aria-label": e.label
          }, {
            default: c(() => [
              u(a(ne), { placeholder: e.placeholder }, null, 8, ["placeholder"]),
              u(a(se), {
                class: "telar-select__icon",
                "aria-hidden": "true"
              }, {
                default: c(() => [...s[1] || (s[1] = [
                  h("▾", -1)
                ])]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["id", "aria-label"]),
          u(a(de), null, {
            default: c(() => [
              u(a(ie), {
                class: "telar-select__content",
                position: "popper",
                "side-offset": 4
              }, {
                default: c(() => [
                  u(a(ce), { class: "telar-select__viewport" }, {
                    default: c(() => [
                      (l(!0), i(x, null, B(e.options, (d) => (l(), g(a(ue), {
                        key: d.value,
                        class: "telar-select__item",
                        value: d.value
                      }, {
                        default: c(() => [
                          u(a(ve), { class: "telar-select__item-indicator" }, {
                            default: c(() => [...s[2] || (s[2] = [
                              h("✓", -1)
                            ])]),
                            _: 1
                          }),
                          u(a(be), null, {
                            default: c(() => [
                              h(b(d.label), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value"]))), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model-value", "disabled"])
    ]));
  }
}), Ua = /* @__PURE__ */ k(ea, [["__scopeId", "data-v-bee741a4"]]), aa = /* @__PURE__ */ m({
  __name: "Tabs",
  props: {
    modelValue: {},
    tabs: {},
    label: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    return (t, r) => {
      var o;
      return l(), g(a(fe), {
        class: "telar-tabs",
        "model-value": e.modelValue,
        "default-value": (o = e.tabs[0]) == null ? void 0 : o.value,
        "onUpdate:modelValue": r[0] || (r[0] = (n) => t.$emit("update:modelValue", String(n)))
      }, {
        default: c(() => [
          u(a(ge), {
            class: "telar-tabs__list",
            "aria-label": e.label
          }, {
            default: c(() => [
              (l(!0), i(x, null, B(e.tabs, (n) => (l(), g(a(me), {
                key: n.value,
                class: "telar-tabs__trigger",
                value: n.value
              }, {
                default: c(() => [
                  h(b(n.label), 1)
                ]),
                _: 2
              }, 1032, ["value"]))), 128))
            ]),
            _: 1
          }, 8, ["aria-label"]),
          (l(!0), i(x, null, B(e.tabs, (n) => (l(), g(a(pe), {
            key: n.value,
            class: "telar-tabs__content",
            value: n.value
          }, {
            default: c(() => [
              $(t.$slots, n.value, {}, void 0, !0)
            ]),
            _: 2
          }, 1032, ["value"]))), 128))
        ]),
        _: 3
      }, 8, ["model-value", "default-value"]);
    };
  }
}), ja = /* @__PURE__ */ k(aa, [["__scopeId", "data-v-78794fd8"]]), T = z([]);
let ta = 0;
function oa() {
  function e(o) {
    const n = ++ta;
    return T.value.push({
      id: n,
      title: o.title,
      description: o.description,
      variant: o.variant ?? "info",
      duration: o.duration ?? 5e3
    }), n;
  }
  function t(o) {
    T.value = T.value.filter((n) => n.id !== o);
  }
  function r() {
    T.value = [];
  }
  return { toasts: N(T), toast: e, dismiss: t, clear: r };
}
const la = { class: "telar-toast__body" }, ra = /* @__PURE__ */ m({
  __name: "ToastProvider",
  setup(e) {
    const { toasts: t, dismiss: r } = oa();
    return (o, n) => (l(), g(a(_e), null, {
      default: c(() => [
        $(o.$slots, "default", {}, void 0, !0),
        (l(!0), i(x, null, B(a(t), (s) => (l(), g(a(ye), {
          key: s.id,
          class: R(["telar-toast", `telar-toast--${s.variant}`]),
          duration: s.duration,
          type: s.variant === "danger" ? "foreground" : "background",
          "onUpdate:open": (d) => !d && a(r)(s.id)
        }, {
          default: c(() => [
            v("div", la, [
              u(a(he), { class: "telar-toast__title" }, {
                default: c(() => [
                  h(b(s.title), 1)
                ]),
                _: 2
              }, 1024),
              s.description ? (l(), g(a(ke), {
                key: 0,
                class: "telar-toast__desc"
              }, {
                default: c(() => [
                  h(b(s.description), 1)
                ]),
                _: 2
              }, 1024)) : y("", !0)
            ]),
            u(a(Se), {
              class: "telar-toast__close",
              "aria-label": "Cerrar"
            }, {
              default: c(() => [...n[0] || (n[0] = [
                v("span", { "aria-hidden": "true" }, "×", -1)
              ])]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["class", "duration", "type", "onUpdate:open"]))), 128)),
        u(a($e), { class: "telar-toast__viewport" })
      ]),
      _: 3
    }));
  }
}), Xa = /* @__PURE__ */ k(ra, [["__scopeId", "data-v-be6e7af0"]]), na = { class: "telar-page-header" }, sa = { class: "telar-page-header__text" }, da = { class: "telar-page-header__title" }, ia = {
  key: 0,
  class: "telar-page-header__desc"
}, ca = {
  key: 0,
  class: "telar-page-header__actions"
}, ua = /* @__PURE__ */ m({
  __name: "PageHeader",
  props: {
    title: {},
    description: {}
  },
  setup(e) {
    return (t, r) => (l(), i("header", na, [
      v("div", sa, [
        v("h1", da, b(e.title), 1),
        e.description ? (l(), i("p", ia, b(e.description), 1)) : y("", !0)
      ]),
      t.$slots.actions ? (l(), i("div", ca, [
        $(t.$slots, "actions", {}, void 0, !0)
      ])) : y("", !0)
    ]));
  }
}), Ea = /* @__PURE__ */ k(ua, [["__scopeId", "data-v-9c00ae4c"]]), va = { class: "telar-datatable" }, ba = { class: "telar-datatable__toolbar" }, fa = ["aria-busy"], ga = { class: "telar-datatable__table" }, ma = { class: "telar-datatable__caption" }, pa = ["aria-sort"], _a = ["onClick"], ya = {
  class: "telar-datatable__sort-icon",
  "aria-hidden": "true"
}, ha = {
  key: 0,
  class: "telar-datatable__state"
}, ka = ["colspan"], Sa = {
  key: 1,
  class: "telar-datatable__state"
}, $a = ["colspan"], xa = { class: "telar-datatable__error" }, Ba = {
  key: 2,
  class: "telar-datatable__state"
}, wa = ["colspan"], Ia = { class: "telar-datatable__footer" }, Ra = { class: "telar-datatable__count" }, Ca = { class: "telar-datatable__pagination" }, Ta = { class: "telar-datatable__page" }, Va = /* @__PURE__ */ m({
  __name: "DataTable",
  props: {
    columns: {},
    data: {},
    caption: {},
    loading: { type: Boolean, default: !1 },
    error: {},
    pageSize: { default: 10 },
    filterLabel: { default: "Buscar" },
    filterPlaceholder: { default: "Filtrar…" },
    emptyMessage: { default: "No hay resultados." }
  },
  emits: ["retry"],
  setup(e, { emit: t }) {
    const r = e, o = t, n = z([]), s = z(""), d = xe({
      get data() {
        return r.data;
      },
      get columns() {
        return r.columns;
      },
      state: {
        get sorting() {
          return n.value;
        },
        get globalFilter() {
          return s.value;
        }
      },
      onSortingChange: (_) => {
        n.value = typeof _ == "function" ? _(n.value) : _;
      },
      onGlobalFilterChange: (_) => {
        s.value = typeof _ == "function" ? _(s.value) : _;
      },
      getCoreRowModel: Re(),
      getSortedRowModel: Ie(),
      getFilteredRowModel: we(),
      getPaginationRowModel: Be(),
      initialState: { pagination: { pageSize: r.pageSize } }
    });
    function C(_) {
      return _ === "asc" ? "ascending" : _ === "desc" ? "descending" : "none";
    }
    return (_, p) => (l(), i("div", va, [
      v("div", ba, [
        u(W, {
          "model-value": s.value,
          label: e.filterLabel,
          placeholder: e.filterPlaceholder,
          type: "search",
          "onUpdate:modelValue": p[0] || (p[0] = (S) => s.value = S)
        }, null, 8, ["model-value", "label", "placeholder"])
      ]),
      v("div", {
        class: "telar-datatable__scroll",
        "aria-busy": e.loading
      }, [
        v("table", ga, [
          v("caption", ma, b(e.caption), 1),
          v("thead", null, [
            (l(!0), i(x, null, B(a(d).getHeaderGroups(), (S) => (l(), i("tr", {
              key: S.id
            }, [
              (l(!0), i(x, null, B(S.headers, (f) => (l(), i("th", {
                key: f.id,
                scope: "col",
                "aria-sort": f.column.getCanSort() ? C(f.column.getIsSorted()) : void 0
              }, [
                f.column.getCanSort() ? (l(), i("button", {
                  key: 0,
                  type: "button",
                  class: "telar-datatable__sort",
                  onClick: (H) => {
                    var G;
                    return (G = f.column.getToggleSortingHandler()) == null ? void 0 : G(H);
                  }
                }, [
                  u(a(M), {
                    render: f.column.columnDef.header,
                    props: f.getContext()
                  }, null, 8, ["render", "props"]),
                  v("span", ya, b(f.column.getIsSorted() === "asc" ? "▲" : f.column.getIsSorted() === "desc" ? "▼" : "↕"), 1)
                ], 8, _a)) : (l(), g(a(M), {
                  key: 1,
                  render: f.column.columnDef.header,
                  props: f.getContext()
                }, null, 8, ["render", "props"]))
              ], 8, pa))), 128))
            ]))), 128))
          ]),
          v("tbody", null, [
            e.loading ? (l(), i("tr", ha, [
              v("td", {
                colspan: e.columns.length
              }, "Cargando…", 8, ka)
            ])) : e.error ? (l(), i("tr", Sa, [
              v("td", {
                colspan: e.columns.length
              }, [
                v("span", xa, b(e.error), 1),
                u(P, {
                  size: "sm",
                  variant: "secondary",
                  onClick: p[1] || (p[1] = (S) => o("retry"))
                }, {
                  default: c(() => [...p[4] || (p[4] = [
                    h("Reintentar", -1)
                  ])]),
                  _: 1
                })
              ], 8, $a)
            ])) : a(d).getRowModel().rows.length === 0 ? (l(), i("tr", Ba, [
              v("td", {
                colspan: e.columns.length
              }, b(e.emptyMessage), 9, wa)
            ])) : (l(!0), i(x, { key: 3 }, B(a(d).getRowModel().rows, (S) => (l(), i("tr", {
              key: S.id
            }, [
              (l(!0), i(x, null, B(S.getVisibleCells(), (f) => (l(), i("td", {
                key: f.id
              }, [
                u(a(M), {
                  render: f.column.columnDef.cell,
                  props: f.getContext()
                }, null, 8, ["render", "props"])
              ]))), 128))
            ]))), 128))
          ])
        ])
      ], 8, fa),
      v("div", Ia, [
        v("span", Ra, b(a(d).getFilteredRowModel().rows.length) + " resultado(s) ", 1),
        v("div", Ca, [
          u(P, {
            size: "sm",
            variant: "secondary",
            disabled: !a(d).getCanPreviousPage(),
            onClick: p[2] || (p[2] = (S) => a(d).previousPage())
          }, {
            default: c(() => [...p[5] || (p[5] = [
              h(" Anterior ", -1)
            ])]),
            _: 1
          }, 8, ["disabled"]),
          v("span", Ta, " Página " + b(a(d).getState().pagination.pageIndex + 1) + " de " + b(Math.max(a(d).getPageCount(), 1)), 1),
          u(P, {
            size: "sm",
            variant: "secondary",
            disabled: !a(d).getCanNextPage(),
            onClick: p[3] || (p[3] = (S) => a(d).nextPage())
          }, {
            default: c(() => [...p[6] || (p[6] = [
              h(" Siguiente ", -1)
            ])]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]));
  }
}), Oa = /* @__PURE__ */ k(Va, [["__scopeId", "data-v-377b9e23"]]), Ya = /* @__PURE__ */ m({
  __name: "FormField",
  props: {
    name: {},
    label: {},
    description: {},
    type: { default: "text" },
    placeholder: {},
    required: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, { value: r, errorMessage: o } = Ce(() => t.name);
    return (n, s) => (l(), g(W, {
      modelValue: a(r),
      "onUpdate:modelValue": s[0] || (s[0] = (d) => U(r) ? r.value = d : null),
      label: e.label,
      description: e.description,
      error: a(o),
      type: e.type,
      placeholder: e.placeholder,
      required: e.required
    }, null, 8, ["modelValue", "label", "description", "error", "type", "placeholder", "required"]));
  }
}), q = "telar-theme", w = z("light");
let A = !1;
function L(e) {
  typeof document > "u" || document.documentElement.setAttribute("data-theme", e);
}
function za() {
  var r;
  const e = typeof localStorage < "u" ? localStorage.getItem(q) : null;
  return e === "light" || e === "dark" ? e : typeof window < "u" && ((r = window.matchMedia) == null ? void 0 : r.call(window, "(prefers-color-scheme: dark)").matches) ? "dark" : "light";
}
function Ka() {
  A || (w.value = za(), L(w.value), j(w, (r) => {
    L(r), typeof localStorage < "u" && localStorage.setItem(q, r);
  }), A = !0);
  function e(r) {
    w.value = r;
  }
  function t() {
    w.value = w.value === "dark" ? "light" : "dark";
  }
  return { theme: w, set: e, toggle: t };
}
const Ja = {
  borderWidthThick: "var(--border-width-thick)",
  borderWidthThin: "var(--border-width-thin)",
  buttonDangerBg: "var(--button-danger-bg)",
  buttonDangerFg: "var(--button-danger-fg)",
  buttonFontWeight: "var(--button-font-weight)",
  buttonPaddingX: "var(--button-padding-x)",
  buttonPaddingY: "var(--button-padding-y)",
  buttonPrimaryBg: "var(--button-primary-bg)",
  buttonPrimaryBgActive: "var(--button-primary-bg-active)",
  buttonPrimaryBgHover: "var(--button-primary-bg-hover)",
  buttonPrimaryFg: "var(--button-primary-fg)",
  buttonRadius: "var(--button-radius)",
  buttonSecondaryBg: "var(--button-secondary-bg)",
  buttonSecondaryBgHover: "var(--button-secondary-bg-hover)",
  buttonSecondaryBorder: "var(--button-secondary-border)",
  buttonSecondaryFg: "var(--button-secondary-fg)",
  cardBg: "var(--card-bg)",
  cardBorder: "var(--card-border)",
  cardPadding: "var(--card-padding)",
  cardRadius: "var(--card-radius)",
  colorAction: "var(--color-action)",
  colorActionActive: "var(--color-action-active)",
  colorActionHover: "var(--color-action-hover)",
  colorActionSubtle: "var(--color-action-subtle)",
  colorAmber100: "var(--color-amber-100)",
  colorAmber400: "var(--color-amber-400)",
  colorAmber500: "var(--color-amber-500)",
  colorAmber600: "var(--color-amber-600)",
  colorBg: "var(--color-bg)",
  colorBgMuted: "var(--color-bg-muted)",
  colorBgSubtle: "var(--color-bg-subtle)",
  colorBlack: "var(--color-black)",
  colorBlue100: "var(--color-blue-100)",
  colorBlue200: "var(--color-blue-200)",
  colorBlue300: "var(--color-blue-300)",
  colorBlue400: "var(--color-blue-400)",
  colorBlue50: "var(--color-blue-50)",
  colorBlue500: "var(--color-blue-500)",
  colorBlue600: "var(--color-blue-600)",
  colorBlue700: "var(--color-blue-700)",
  colorBlue800: "var(--color-blue-800)",
  colorBlue900: "var(--color-blue-900)",
  colorBorder: "var(--color-border)",
  colorBorderStrong: "var(--color-border-strong)",
  colorDanger: "var(--color-danger)",
  colorDangerSubtle: "var(--color-danger-subtle)",
  colorFocusRing: "var(--color-focus-ring)",
  colorGray100: "var(--color-gray-100)",
  colorGray200: "var(--color-gray-200)",
  colorGray300: "var(--color-gray-300)",
  colorGray400: "var(--color-gray-400)",
  colorGray50: "var(--color-gray-50)",
  colorGray500: "var(--color-gray-500)",
  colorGray600: "var(--color-gray-600)",
  colorGray700: "var(--color-gray-700)",
  colorGray800: "var(--color-gray-800)",
  colorGray900: "var(--color-gray-900)",
  colorGray950: "var(--color-gray-950)",
  colorGreen100: "var(--color-green-100)",
  colorGreen400: "var(--color-green-400)",
  colorGreen500: "var(--color-green-500)",
  colorGreen600: "var(--color-green-600)",
  colorGreen700: "var(--color-green-700)",
  colorLink: "var(--color-link)",
  colorLinkHover: "var(--color-link-hover)",
  colorOverlay: "var(--color-overlay)",
  colorRed100: "var(--color-red-100)",
  colorRed400: "var(--color-red-400)",
  colorRed500: "var(--color-red-500)",
  colorRed600: "var(--color-red-600)",
  colorRed700: "var(--color-red-700)",
  colorSuccess: "var(--color-success)",
  colorSuccessSubtle: "var(--color-success-subtle)",
  colorSurface: "var(--color-surface)",
  colorSurfaceRaised: "var(--color-surface-raised)",
  colorText: "var(--color-text)",
  colorTextMuted: "var(--color-text-muted)",
  colorTextOnAction: "var(--color-text-on-action)",
  colorTextSubtle: "var(--color-text-subtle)",
  colorWarning: "var(--color-warning)",
  colorWarningSubtle: "var(--color-warning-subtle)",
  colorWhite: "var(--color-white)",
  elevationModal: "var(--elevation-modal)",
  elevationRaised: "var(--elevation-raised)",
  fontFamilyMono: "var(--font-family-mono)",
  fontFamilySans: "var(--font-family-sans)",
  fontLeadingNormal: "var(--font-leading-normal)",
  fontLeadingRelaxed: "var(--font-leading-relaxed)",
  fontLeadingTight: "var(--font-leading-tight)",
  fontSize2xl: "var(--font-size-2xl)",
  fontSize3xl: "var(--font-size-3xl)",
  fontSizeLg: "var(--font-size-lg)",
  fontSizeMd: "var(--font-size-md)",
  fontSizeSm: "var(--font-size-sm)",
  fontSizeXl: "var(--font-size-xl)",
  fontSizeXs: "var(--font-size-xs)",
  fontWeightBold: "var(--font-weight-bold)",
  fontWeightMedium: "var(--font-weight-medium)",
  fontWeightRegular: "var(--font-weight-regular)",
  fontWeightSemibold: "var(--font-weight-semibold)",
  iconLg: "var(--icon-lg)",
  iconMd: "var(--icon-md)",
  iconSm: "var(--icon-sm)",
  inputBg: "var(--input-bg)",
  inputBorder: "var(--input-border)",
  inputBorderFocus: "var(--input-border-focus)",
  inputFg: "var(--input-fg)",
  inputPlaceholder: "var(--input-placeholder)",
  inputRadius: "var(--input-radius)",
  radiusFull: "var(--radius-full)",
  radiusLg: "var(--radius-lg)",
  radiusMd: "var(--radius-md)",
  radiusNone: "var(--radius-none)",
  radiusSm: "var(--radius-sm)",
  radiusXl: "var(--radius-xl)",
  shadowLg: "var(--shadow-lg)",
  shadowMd: "var(--shadow-md)",
  shadowSm: "var(--shadow-sm)",
  space0: "var(--space-0)",
  space1: "var(--space-1)",
  space10: "var(--space-10)",
  space12: "var(--space-12)",
  space16: "var(--space-16)",
  space2: "var(--space-2)",
  space2xl: "var(--space-2xl)",
  space3: "var(--space-3)",
  space4: "var(--space-4)",
  space5: "var(--space-5)",
  space6: "var(--space-6)",
  space8: "var(--space-8)",
  spaceLg: "var(--space-lg)",
  spaceMd: "var(--space-md)",
  spaceNone: "var(--space-none)",
  spaceSm: "var(--space-sm)",
  spaceXl: "var(--space-xl)",
  spaceXs: "var(--space-xs)",
  textBody: "var(--text-body)",
  textCaption: "var(--text-caption)",
  textHeading: "var(--text-heading)"
}, Qa = "0.1.0";
export {
  Ga as Box,
  P as Button,
  Ha as Checkbox,
  Oa as DataTable,
  Ya as FormField,
  Wa as Icon,
  W as Input,
  qa as Modal,
  Ea as PageHeader,
  Na as RadioGroup,
  Ua as Select,
  Aa as Stack,
  ja as Tabs,
  La as Text,
  Xa as ToastProvider,
  Ja as tokens,
  Ka as useTheme,
  oa as useToast,
  Qa as version
};
